const appController = function(
  APP,
  APP_VERSION,
  Events
) {
  let vm = this;
  vm.events = Events;

  // Defaults
  vm.appVersion = APP_VERSION;
  vm.googleStatus = APP.googleStatus;
};

appController['$inject'] = ['APP', 'APP_VERSION', 'Events'];

export const inkApp = {
  template: require('./app.template.html'),
  controller: appController
};



// WEBPACK FOOTER //
// ./app.component.js